import { useQuery, useMutation } from '@tanstack/react-query';
import { getVehicleListByUserIdApi, updateVehicleApi, deleteVehicleApi } from './vehicle.api';

export const vehicleKeys = {
    all: ['vehicles'],
    lists: () => [...vehicleKeys.all, 'list'],
    list: (userId) => [...vehicleKeys.lists(), userId],
};

/**
 * Hook to get vehicle list by user ID
 * @param {string} userId - Customer ID
 * @param {object} options - React Query options
 */
export const useGetVehicleListByUserId = (userId, options = {}) => {
    return useQuery({
        queryKey: vehicleKeys.list(userId),
        queryFn: () => getVehicleListByUserIdApi(userId),
        enabled: !!userId,
        staleTime: 0, // Always fetch fresh data
        gcTime: 0, // Don't cache (formerly cacheTime)
        refetchOnMount: true,
        refetchOnWindowFocus: true,
        ...options,
    });
};

export const useUpdateVehicle = (options = {}) => {
    return useMutation({
        mutationFn: updateVehicleApi,
        ...options,
    });
};

export const useDeleteVehicle = (options = {}) => {
    return useMutation({
        mutationFn: deleteVehicleApi,
        ...options,
    });
};
